import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';
import { ImportType } from '../../../../../../../../components/csv-import/data/types/import-type';
import { useImportContext } from '../../../../../../../../components/csv-import/ui/components/import-context';
import { useStepDetectiveContext } from '../../../../../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { useCanStartImport } from '../../../../../../../../components/csv-import/ui/hooks/use-can-start-import';
import { useCsvImport } from '../../../../../../../../components/csv-import/ui/hooks/use-csv-import';
import { addMetadataToImport } from '../../../../../../../../store/csv-import/csv-import.actions';

/**
 * @returns {React.JSX.Element}
 */
export const MappingImportStepFooter = () => {
  const { close } = useCsvImport(ImportType.fulfillmentProduct);
  const { onImport, isImportLoading, validateUserMapping, isMappingResultValid, initRequest } = useImportContext();

  const { goToNext } = useStepDetectiveContext();

  const dispatch = useDispatch();

  const onImportClick = () => {
    const isValid = validateUserMapping();
    if (!isValid || !isMappingResultValid) {
      return;
    }

    const onSuccess = () => {
      dispatch(
        addMetadataToImport({
          importType: ImportType.fulfillmentProduct,
          metadata: {
            fileName: initRequest.csvFile.name,
          },
        }),
      );
      goToNext();
    };

    onImport(onSuccess);
  };

  const isStartImportBtnDisabled = useCanStartImport();

  return (
    <>
      <Button className={styles['back-btn']} disabled={isImportLoading} onClick={close} theme={THEME_CONSTANTS.link}>
        <FontAwesomeIcon className={styles.icon} icon={faArrowLeft} />
        <FormattedMessage {...messages.backBtn} />
      </Button>
      <Button
        className={styles['continue-btn']}
        disabled={isStartImportBtnDisabled}
        onClick={onImportClick}
        theme={THEME_CONSTANTS.primary}
      >
        <FormattedMessage {...messages.startImportBtn} />
      </Button>
    </>
  );
};
